module.exports = __webpack_public_path__ + "img/wansheng-pop.5a61b974.png";